import { render, staticRenderFns } from "./EmployeeFormSubmissionDepartmentCard.vue?vue&type=template&id=56673760&"
import script from "./EmployeeFormSubmissionDepartmentCard.vue?vue&type=script&lang=ts&"
export * from "./EmployeeFormSubmissionDepartmentCard.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeFormSubmissionDepartmentCard.vue?vue&type=style&index=0&id=56673760&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports